/* Єдиний реєстр: одна сутність на кожну людину, організацію й тварину (/registry). Kept apart from uk.ts/en.ts to keep merges small. */
export const registryUk = {
  'nav.registry': 'Єдиний реєстр',
  'perm.registry.read': 'Єдиний реєстр: пошук людей, організацій і тварин з усіма пов’язаними записами',
  'perm.registry.manage': 'Єдиний реєстр: об’єднання, розділення й рішення черги перевірки',
  'reg.title': 'Єдиний реєстр',
  'reg.subtitle':
    'Кожна людина, організація й тварина — один запис. Картки з Enote, BAS, Checkbox, AI SIP, кадрів і постачальників прив’язані до нього, а не скопійовані.',
  'reg.tabSearch': 'Пошук',
  'reg.tabReview': 'Перевірка збігів',
  'reg.tabStats': 'Покриття',
  'reg.searchPlaceholder': 'Прізвище (будь-яким написанням), телефон, e-mail, ЄДРПОУ або id',
  'reg.allKinds': 'Усі типи',
  'reg.multiOnly': 'Лише з кількох джерел',
  'reg.kind.person': 'Людина',
  'reg.kind.organization': 'Організація',
  'reg.kind.pet': 'Тварина',
  'reg.recent': 'Нещодавно змінені',
  'reg.noResults': 'Нікого не знайдено',
  'reg.noResultsHint': 'Спробуйте інше написання прізвища, номер телефону або ЄДРПОУ. Реєстр наповнюється автоматично кожні 10 хвилин.',
  'reg.empty': 'Реєстр ще порожній',
  'reg.emptyHint': 'Зв’язування джерел запускається автоматично кожні 10 хвилин. Можна запустити зараз на вкладці «Покриття».',
  'reg.records': 'Записи',
  'reg.reviewsOpen': 'на перевірці',
  'reg.match.name': 'за ім’ям',
  'reg.match.phone': 'за телефоном',
  'reg.match.email': 'за e-mail',
  'reg.match.edrpou': 'за ЄДРПОУ',
  'reg.match.id': 'за id',
  // entity card
  'reg.fields': 'Відомості',
  'reg.fieldsHint': 'Значення з джерела з найвищим пріоритетом; ручне значення важливіше за всі джерела.',
  'reg.noFields': 'Джерела не передали жодних відомостей',
  'reg.linked': 'Пов’язані записи',
  'reg.relations': 'Зв’язки',
  'reg.noRelations': 'Зв’язків немає',
  'reg.hiddenRecords': 'Ще {n} записів з джерел, до яких у вас немає доступу',
  'reg.masked': 'приховано',
  'reg.maskedHint': 'Персональні дані видно лише людям з доступом «Кадри: персональні дані»; через API/MCP — ніколи.',
  'reg.otherValues': 'Інші значення',
  'reg.from': 'з {source}',
  'reg.open': 'Відкрити в модулі',
  'reg.split': 'Відокремити',
  'reg.splitTitle': 'Відокремити запис?',
  'reg.splitHint': '«{name}» стане окремою сутністю. Реєстр запам’ятає, що це не та сама людина чи організація, і більше не зв’яже їх автоматично.',
  'reg.splitDone': 'Запис відокремлено',
  'reg.mergeInto': 'Об’єднати з…',
  'reg.mergeTitle': 'Об’єднати сутності',
  'reg.mergeHint': 'Усі записи, зв’язки й ручні значення знайденої сутності перейдуть до цієї. Помилковий запис потім можна відокремити.',
  'reg.mergeSearch': 'Знайдіть сутність того ж типу',
  'reg.mergeDone': 'Сутності об’єднано',
  'reg.reason': 'Причина (необов’язково)',
  'reg.status.proposed': 'на перевірці',
  'reg.deleted': 'видалено в джерелі',
  'reg.locked': 'рішення людини',
  'reg.method.new': 'новий',
  'reg.method.key': 'точний збіг',
  'reg.method.weak': 'збіг двох ознак',
  'reg.method.merge': 'об’єднано вручну',
  'reg.method.review': 'підтверджено',
  'reg.method.full_name_unique': 'унікальне повне ПІБ',
  'reg.method.split': 'відокремлено',
  'reg.method.manual': 'вручну',
  'reg.rel.employment': 'Працює в',
  'reg.rel.employment.in': 'Працівник',
  'reg.rel.owner': 'Власник тварини',
  'reg.rel.owner.in': 'Власник',
  'reg.rel.fop_owner': 'ФОП цієї людини',
  'reg.rel.fop_owner.in': 'Власник ФОП',
  'reg.rel.contact_of': 'Контактна особа клієнта',
  'reg.rel.contact_of.in': 'Контактна особа',
  'reg.rel.family': 'Член родини',
  'reg.rel.family.in': 'Член родини',
  'reg.rel.unresolved': 'запис ще не зв’язано',
  'reg.notFound': 'Сутність не знайдено або немає доступу',
  // fields
  'reg.field.name': 'Назва / ПІБ',
  'reg.field.full_name': 'Повна назва',
  'reg.field.surname': 'Прізвище',
  'reg.field.first_name': 'Ім’я',
  'reg.field.patronymic': 'По батькові',
  'reg.field.legal_kind': 'Юр./фіз. особа',
  'reg.field.legal_form': 'Форма',
  'reg.field.edrpou': 'ЄДРПОУ',
  'reg.field.rnokpp': 'РНОКПП',
  'reg.field.birth_date': 'Дата народження',
  'reg.field.phone': 'Телефон',
  'reg.field.email': 'E-mail',
  'reg.field.address': 'Адреса',
  'reg.field.position': 'Посада',
  'reg.field.branch': 'Філія',
  'reg.field.status': 'Статус',
  'reg.field.hired_on': 'Прийнято',
  'reg.field.dismissed_on': 'Звільнено',
  'reg.field.species': 'Вид',
  'reg.field.breed': 'Порода',
  'reg.field.sex': 'Стать',
  'reg.field.chip': 'Чип',
  'reg.field.blood_group': 'Група крові',
  'reg.field.deceased_on': 'Дата смерті',
  'reg.field.tax_group': 'Група ЄП',
  'reg.field.city': 'Місто',
  'reg.field.iban': 'IBAN',
  'reg.field.cash_register': 'Каса Checkbox',
  'reg.field.fiscal_number': 'Фіскальний номер',
  'reg.field.money_account': 'Грошовий рахунок',
  'reg.field.relationship': 'Ким доводиться',
  'reg.field.account_status': 'Обліковий запис',
  'reg.field.sip_extension': 'Внутрішній номер',
  'reg.field.donor_status': 'Статус донора',
  // sources
  'reg.src.manual': 'Вручну',
  'reg.src.enote.employee': 'Enote: працівник',
  'reg.src.bridge.user': 'Обліковий запис Bridge',
  'reg.src.hr.employee': 'Картка працівника',
  'reg.src.drive.hr': 'Google Drive (кадри)',
  'reg.src.aisip.operator': 'AI SIP: оператор',
  'reg.src.bas.person': 'BAS: фізична особа',
  'reg.src.bas.employee': 'BAS: працівник',
  'reg.src.bridge.fop': 'ФОП (Bridge)',
  'reg.src.bridge.fop_staff': 'Працівник ФОП',
  'reg.src.enote.org': 'Enote: організація',
  'reg.src.bas.organization': 'BAS: організація',
  'reg.src.bas.counterparty': 'BAS: контрагент',
  'reg.src.supply.supplier': 'Постачальник',
  'reg.src.checkbox.register': 'Каса Checkbox',
  'reg.src.enote.money_account': 'Enote: грошовий рахунок',
  'reg.src.labship.lab': 'Зовнішня лабораторія',
  'reg.src.enote.client': 'Enote: клієнт',
  'reg.src.enote.contact_person': 'Enote: контактна особа',
  'reg.src.bridge.client_account': 'Застосунок клієнта',
  'reg.src.enote.pet': 'Enote: пацієнт',
  'reg.src.bloodbank.donor': 'Донор крові',
  // review
  'reg.reviewHint':
    'Записи, які можуть бути тією самою людиною, організацією чи твариною, але збіглася лише одна ознака. Рішення «різні» запам’ятовується — пара більше не з’явиться.',
  'reg.noReviews': 'Немає збігів на перевірку',
  'reg.noReviewsHint': 'Нові збіги з’являються після кожного зв’язування джерел.',
  'reg.reviewRecord': 'Запис',
  'reg.candidates': 'Можливо, це',
  'reg.evidence': 'Збіглося: {list}',
  'reg.reason.name': 'ім’я',
  'reg.reason.dob': 'дата народження',
  'reg.reason.phone': 'телефон',
  'reg.reason.email': 'e-mail',
  'reg.same': 'Це одне й те саме',
  'reg.different': 'Різні',
  'reg.dismiss': 'Відкласти',
  'reg.decided': 'Рішення збережено',
  'reg.statusFilter.open': 'Відкриті',
  'reg.statusFilter.all': 'Усі',
  // stats
  'reg.statsSources': 'Покриття джерел',
  'reg.statsHint': 'Скільки записів кожного джерела вже прив’язано до сутностей і скільки з них знайдено ще в інших джерелах.',
  'reg.col.source': 'Джерело',
  'reg.col.rows': 'Рядків',
  'reg.col.linked': 'Прив’язано',
  'reg.col.shared': 'Є в інших джерелах',
  'reg.col.duplicates': 'Дублікати в джерелі',
  'reg.col.proposed': 'На перевірці',
  'reg.entities': 'Сутностей',
  'reg.multi': 'з кількох джерел',
  'reg.mergedCount': 'дублікатів об’єднано',
  'reg.openReviews': 'Збігів на перевірці',
  'reg.decisions': 'Рішень людей',
  'reg.backfill': 'Зв’язування',
  'reg.backfillDone': 'Усі джерела прочитано; далі — лише зміни кожні 10 хвилин.',
  'reg.backfillPending': 'Триває перше читання джерел: {done} з {total}.',
  'reg.runNow': 'Зв’язати зараз',
  'reg.runRestart': 'Перечитати все',
  'reg.runQueued': 'Зв’язування запущено',
  'reg.external': 'зв’язує модуль «Кадри»',
  // consumers
  'reg.linkedElsewhere': 'Та сама сутність в інших джерелах',
  'reg.openInRegistry': 'Відкрити в реєстрі',
}

export const registryEn: Partial<Record<keyof typeof registryUk, string>> = {
  'nav.registry': 'Single registry',
  'perm.registry.read': 'Single registry: search people, organizations and pets with all their linked records',
  'perm.registry.manage': 'Single registry: merge, split and decide the review queue',
  'reg.title': 'Single registry',
  'reg.subtitle':
    'Every person, organization and pet is one record. Cards from Enote, BAS, Checkbox, AI SIP, HR and suppliers are linked to it, not copied.',
  'reg.tabSearch': 'Search',
  'reg.tabReview': 'Possible matches',
  'reg.tabStats': 'Coverage',
  'reg.searchPlaceholder': 'Surname (any spelling), phone, e-mail, ЄДРПОУ or id',
  'reg.allKinds': 'All kinds',
  'reg.multiOnly': 'Only from several sources',
  'reg.kind.person': 'Person',
  'reg.kind.organization': 'Organization',
  'reg.kind.pet': 'Pet',
  'reg.recent': 'Recently changed',
  'reg.noResults': 'Nothing found',
  'reg.noResultsHint': 'Try another spelling of the surname, a phone number or ЄДРПОУ. The registry fills itself every 10 minutes.',
  'reg.empty': 'The registry is still empty',
  'reg.emptyHint': 'Sources are linked automatically every 10 minutes. You can start it now on the Coverage tab.',
  'reg.records': 'Records',
  'reg.reviewsOpen': 'in review',
  'reg.match.name': 'by name',
  'reg.match.phone': 'by phone',
  'reg.match.email': 'by e-mail',
  'reg.match.edrpou': 'by ЄДРПОУ',
  'reg.match.id': 'by id',
  'reg.fields': 'Details',
  'reg.fieldsHint': 'The value of the highest-priority source; a manual value beats every source.',
  'reg.noFields': 'The sources sent no details',
  'reg.linked': 'Linked records',
  'reg.relations': 'Relations',
  'reg.noRelations': 'No relations',
  'reg.hiddenRecords': '{n} more records from sources you have no access to',
  'reg.masked': 'hidden',
  'reg.maskedHint': 'Personal data is shown only to people with «HR: personal data»; never over API/MCP.',
  'reg.otherValues': 'Other values',
  'reg.from': 'from {source}',
  'reg.open': 'Open in module',
  'reg.split': 'Split off',
  'reg.splitTitle': 'Split this record off?',
  'reg.splitHint': '«{name}» becomes an entity of its own. The registry remembers it is not the same person or organization and never links them again automatically.',
  'reg.splitDone': 'Record split off',
  'reg.mergeInto': 'Merge with…',
  'reg.mergeTitle': 'Merge entities',
  'reg.mergeHint': 'All records, relations and manual values of the found entity move to this one. A wrong record can be split off later.',
  'reg.mergeSearch': 'Find an entity of the same kind',
  'reg.mergeDone': 'Entities merged',
  'reg.reason': 'Reason (optional)',
  'reg.status.proposed': 'in review',
  'reg.deleted': 'deleted in the source',
  'reg.locked': 'decided by a person',
  'reg.method.new': 'new',
  'reg.method.key': 'exact key',
  'reg.method.weak': 'two signs agree',
  'reg.method.merge': 'merged by hand',
  'reg.method.review': 'confirmed',
  'reg.method.full_name_unique': 'unique full name',
  'reg.method.split': 'split off',
  'reg.method.manual': 'manual',
  'reg.rel.employment': 'Works at',
  'reg.rel.employment.in': 'Employee',
  'reg.rel.owner': 'Owns pet',
  'reg.rel.owner.in': 'Owner',
  'reg.rel.fop_owner': 'Their ФОП',
  'reg.rel.fop_owner.in': 'ФОП owner',
  'reg.rel.contact_of': 'Contact person of client',
  'reg.rel.contact_of.in': 'Contact person',
  'reg.rel.family': 'Family member',
  'reg.rel.family.in': 'Family member',
  'reg.rel.unresolved': 'record not linked yet',
  'reg.notFound': 'Entity not found or no access',
  'reg.field.name': 'Name',
  'reg.field.full_name': 'Full name',
  'reg.field.surname': 'Surname',
  'reg.field.first_name': 'First name',
  'reg.field.patronymic': 'Patronymic',
  'reg.field.legal_kind': 'Legal / natural person',
  'reg.field.legal_form': 'Form',
  'reg.field.edrpou': 'ЄДРПОУ',
  'reg.field.rnokpp': 'Tax number',
  'reg.field.birth_date': 'Birth date',
  'reg.field.phone': 'Phone',
  'reg.field.email': 'E-mail',
  'reg.field.address': 'Address',
  'reg.field.position': 'Position',
  'reg.field.branch': 'Branch',
  'reg.field.status': 'Status',
  'reg.field.hired_on': 'Hired',
  'reg.field.dismissed_on': 'Left',
  'reg.field.species': 'Species',
  'reg.field.breed': 'Breed',
  'reg.field.sex': 'Sex',
  'reg.field.chip': 'Chip',
  'reg.field.blood_group': 'Blood group',
  'reg.field.deceased_on': 'Died',
  'reg.field.tax_group': 'Single-tax group',
  'reg.field.city': 'City',
  'reg.field.iban': 'IBAN',
  'reg.field.cash_register': 'Checkbox register',
  'reg.field.fiscal_number': 'Fiscal number',
  'reg.field.money_account': 'Money account',
  'reg.field.relationship': 'Relationship',
  'reg.field.account_status': 'Account',
  'reg.field.sip_extension': 'Extension',
  'reg.field.donor_status': 'Donor status',
  'reg.src.manual': 'Manual',
  'reg.src.enote.employee': 'Enote: employee',
  'reg.src.bridge.user': 'Bridge account',
  'reg.src.hr.employee': 'Employee card',
  'reg.src.drive.hr': 'Google Drive (HR)',
  'reg.src.aisip.operator': 'AI SIP: operator',
  'reg.src.bas.person': 'BAS: natural person',
  'reg.src.bas.employee': 'BAS: employee',
  'reg.src.bridge.fop': 'ФОП (Bridge)',
  'reg.src.bridge.fop_staff': 'ФОП staff',
  'reg.src.enote.org': 'Enote: organisation',
  'reg.src.bas.organization': 'BAS: organization',
  'reg.src.bas.counterparty': 'BAS: counterparty',
  'reg.src.supply.supplier': 'Supplier',
  'reg.src.checkbox.register': 'Checkbox register',
  'reg.src.enote.money_account': 'Enote: money account',
  'reg.src.labship.lab': 'External laboratory',
  'reg.src.enote.client': 'Enote: client',
  'reg.src.enote.contact_person': 'Enote: contact person',
  'reg.src.bridge.client_account': 'Client app',
  'reg.src.enote.pet': 'Enote: patient',
  'reg.src.bloodbank.donor': 'Blood donor',
  'reg.reviewHint':
    'Records that may be the same person, organization or pet, but only one sign agrees. «Different» is remembered — the pair never comes back.',
  'reg.noReviews': 'No possible matches to check',
  'reg.noReviewsHint': 'New ones appear after each linking run.',
  'reg.reviewRecord': 'Record',
  'reg.candidates': 'Possibly',
  'reg.evidence': 'Agrees: {list}',
  'reg.reason.name': 'name',
  'reg.reason.dob': 'birth date',
  'reg.reason.phone': 'phone',
  'reg.reason.email': 'e-mail',
  'reg.same': 'Same',
  'reg.different': 'Different',
  'reg.dismiss': 'Later',
  'reg.decided': 'Decision saved',
  'reg.statusFilter.open': 'Open',
  'reg.statusFilter.all': 'All',
  'reg.statsSources': 'Source coverage',
  'reg.statsHint': 'How many records of each source are linked to entities and how many were found in other sources too.',
  'reg.col.source': 'Source',
  'reg.col.rows': 'Rows',
  'reg.col.linked': 'Linked',
  'reg.col.shared': 'In other sources',
  'reg.col.duplicates': 'Duplicates inside',
  'reg.col.proposed': 'In review',
  'reg.entities': 'Entities',
  'reg.multi': 'from several sources',
  'reg.mergedCount': 'duplicates merged',
  'reg.openReviews': 'Matches to check',
  'reg.decisions': 'Human decisions',
  'reg.backfill': 'Linking',
  'reg.backfillDone': 'All sources read; from now on only changes, every 10 minutes.',
  'reg.backfillPending': 'The first read of the sources is running: {done} of {total}.',
  'reg.runNow': 'Link now',
  'reg.runRestart': 'Re-read everything',
  'reg.runQueued': 'Linking started',
  'reg.external': 'linked by the HR office module',
  'reg.linkedElsewhere': 'The same entity in other sources',
  'reg.openInRegistry': 'Open in the registry',
}
